// extracted by mini-css-extract-plugin
module.exports = {"intro":"account-type-view_intro__1NNo2","title":"account-type-view_title__-70Je","primaryEditButton":"account-type-view_primaryEditButton__2UC0f"};